import type { AdminStripeProductLinkDto } from "@intelligems/ig-types";
import { getModuleIdByModuleName } from "@src/components/BillingSettings2026/workflow";

export type ApprovalModule = {
  id?: string;
};

export const buildApprovalModules = (
  stripeProductLinks: AdminStripeProductLinkDto[]
): ApprovalModule[] =>
  stripeProductLinks
    .map((link) => link.stripeProduct)
    .filter((product): product is NonNullable<typeof product> =>
      Boolean(product)
    )
    .map((product) => ({
      id: getModuleIdByModuleName(product.name),
    }));
